import './LandingFooter.css'

export function LandingFooter() {
  return (
    <footer className="landing-footer">
      <div className="lfoot-inner">
        <div className="lfoot-grid">
          {/* Brand */}
          <div className="lfoot-brand">
            <h3 className="lfoot-brand-name">ChatArchiv.de</h3>
            <p className="lfoot-brand-desc">
              Die professionelle Lösung, um deine wertvollsten WhatsApp-Gespräche in
              wunderschöne PDFs zu verwandeln. Sicher, privat und für die Ewigkeit.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="lfoot-col-title">Navigation</h4>
            <ul className="lfoot-links">
              <li><a href="#so-funktioniert">So funktioniert's</a></li>
              <li><a href="#funktionen">Funktionen</a></li>
              <li><a href="#preise">Preise</a></li>
              <li><a href="#faq">FAQ</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="lfoot-col-title">Rechtliches</h4>
            <ul className="lfoot-links">
              <li><a href="/impressum.html" target="_blank" rel="noopener">Impressum</a></li>
              <li><a href="/datenschutz.html" target="_blank" rel="noopener">Datenschutz</a></li>
              <li><a href="/agb.html" target="_blank" rel="noopener">AGB</a></li>
            </ul>
          </div>
        </div>

        <div className="lfoot-bottom">
          <p className="lfoot-copy">© 2026 ChatArchiv.de. Alle Rechte vorbehalten.</p>
          <p className="lfoot-made">Made with <span className="lfoot-heart">💚</span> in Germany</p>
        </div>
      </div>
    </footer>
  )
}
